import moment from "moment";
import Component from "vue-class-component";
import { DemandeDpaeDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeDpaeDto";
import { DemandeDpaeEtatEnum } from "../../dto/GenApi.iNotPaie.Dto/DemandeDpaeEtatEnum";
import { LigneDemandeDpaeDto } from "../../dto/GenApi.iNotPaie.Dto/LigneDemandeDpaeDto";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { ColorServiceInstance } from "../../shared/services/color.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalDemandeDpae from "./modalDemandeDpae/modalDemandeDpae";

@Component({
	components: {
		ModalDemandeDpae: require("./modalDemandeDpae/modalDemandeDpae.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as DemandeDpaeComponent);
			vm.init();
		});
	}
})
export default class DemandeDpaeComponent extends VueBase {
	public filtreEtat = "ARealiser";
	public filtreRecherche = "";
	public currentOrderColumn = "DebutContrat";
	public orderingDesc = false;
	public dataReady = false;
	public listeDemandes: LigneDemandeDpaeDto[] = [];
	public listeDemandesFiltered: LigneDemandeDpaeDto[] = [];
	public modalDemandeDpae?: ModalDemandeDpae;
	private colorService = ColorServiceInstance;

	public init(): void {
    	this.fetchData();
	}

	public fetchData(): void {
    	this.dataReady = false;
    	ServicesFactoryInstance.DpaeService.getLignesEtRafraichitDemandesDpae(data => {
    		this.resetData(data);
    	}, () => {
    		this.dataReady = true;
    	});
	}

	public telechargerDocument(ligneDemande: LigneDemandeDpaeDto): void {
    	if (ligneDemande.IdDemandeHistorique == undefined) {
    		return;
    	}

    	this.dataReady = false;

    	if (ligneDemande.CodeDocumentGedAttestation !== undefined && ligneDemande.CodeDocumentGedAttestation !== "") {
    		this.getAttestationFromGed(ligneDemande);
    	} else {
    		this.genererAttestation(ligneDemande);
    	}
	}

	public openModalDemandeDpae(demande: LigneDemandeDpaeDto): void {
    	this.modalDemandeDpae = this.$refs.modalDemandeDpae as ModalDemandeDpae;
    	if (this.modalDemandeDpae == undefined) {
    		return;
    	}

    	this.modalDemandeDpae.init(demande);
	}

	public openModalAlerteRenvoiDpae(demande: DemandeDpaeDto): void {
    	const modalAlerteRenvoiDpaeOptions: ModalAlerteOptions = new ModalAlerteOptions({
    		message: "En cliquant sur confirmer, vous serez redirigé vers un nouveau formulaire. <br /><br /> Souhaitez-vous continuer ?",
    		callBackYes: () => {
    			this.ouvrirFormulaireRenvoi(demande);
    		},
    		callBackNo: () => {
    			this.dataReady = true;
    		}
    	});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteRenvoiDpaeOptions);
	}

	public ouvrirFormulaireRenvoi(demande: DemandeDpaeDto): void {
    	// Cache le tableau des demandes pour éviter que l'utilisateur rouvre la popup avant qu'elle s'ouvre automatiquement
    	this.dataReady = false;

    	ServicesFactoryInstance.DpaeService.getDemandeDpaeFromContrat(demande.IdContrat, data => {
    		// Ouvre le formulaire d'envoi avec les informations rafraichies
    		this.openModalDemandeDpae(data);

    		this.dataReady = true;
    	}, () => {
    		// Raffiche le tableau des demandes
    		NotificationServiceInstance.SendFailed("Erreur lors de la récupération des infos pour la demande DPAE");
    		this.dataReady = true;
    	});
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	if (this.listeDemandesFiltered != undefined) {
    		const orderingDesc = this.orderingDesc;
    		const columnName = this.currentOrderColumn;

    		this.listeDemandesFiltered = this.listeDemandesFiltered.sort(function(a, b) {
    			const valueA = a[columnName];
    			const valueB = b[columnName];

    			if (valueA === valueB) {
    				return 0;
    			}

    			// Order des dates
    			const dateA = new Date(valueA);
    			const dateB = new Date(valueB);

    			if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
    				if (dateA < dateB) {
    					return orderingDesc ? -1 : 1;
    				}
    				if (dateA > dateB) {
    					return orderingDesc ? 1 : -1;
    				}
    			}

    			// Order des strings
    			if (valueA < valueB) {
    				return orderingDesc ? -1 : 1;
    			}
    			if (valueA > valueB) {
    				return orderingDesc ? 1 : -1;
    			}

    			return 0;
    		});
    	}
	}

	public showOrderArrow(columnName: string, desc: boolean): string {
    	if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "";
	}

	public doFilter(): void {
    	this.listeDemandesFiltered = this.listeDemandes.filter((demande) => {
    		if (this.filtreEtat == "Tout") {
    			return true;
    		}
    		if (demande.Etat == undefined) {
    			return false;
    		}

    		return DemandeDpaeEtatEnum[demande.Etat] == this.filtreEtat;
    	});

    	this.doOrder();
	}

	public doFilterRecherche(): void {
    	if (this.filtreRecherche == undefined || this.filtreRecherche == "") {
    		this.listeDemandesFiltered = this.listeDemandes;

    		return;
    	} else {
    		this.listeDemandesFiltered = this.listeDemandes.filter(demande =>
    			(demande.Nom != undefined && (demande.Nom.toUpperCase().indexOf(this.filtreRecherche.toUpperCase()) >= 0) ||
                (demande.Prenom != undefined && demande.Prenom.toString().toUpperCase().indexOf(this.filtreRecherche.toUpperCase()) >= 0) ||
                (demande.NomNaissance != undefined && demande.NomNaissance.toString().toUpperCase().indexOf(this.filtreRecherche.toUpperCase()) >= 0)));
    	}

    	this.doOrder();
	}

	private resetData(data: LigneDemandeDpaeDto[]): void {
    	this.listeDemandes = data;
    	this.doFilter();
    	this.dataReady = true;
	}

	private genererNomDocumentAttestation(ligneDemande: LigneDemandeDpaeDto): string {
    	const typeDocument = "_DPAE_";
    	const nomFichier = moment(ligneDemande.DateDepotDemande).format("YYYY_MM_DD") + typeDocument + ligneDemande.NomNaissance + "_" + ligneDemande.Prenom;

    	return nomFichier;
	}

	private getAttestationFromGed(ligneDemande: LigneDemandeDpaeDto): void {
    	if (ligneDemande.CodeDocumentGedAttestation === undefined || ligneDemande.CodeDocumentGedAttestation === "") {
    		return;
    	}

    	const nomDocument = this.genererNomDocumentAttestation(ligneDemande);
    	ServicesFactoryInstance.GedService.getDocument(ligneDemande.CodeDocumentGedAttestation, data => {
    		this.telechargerPdf(data, nomDocument);
    		this.dataReady = true;
    	}, () => {
    		NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération de l'attestation DPAE");
    		this.dataReady = true;
    	});
	}

	private genererAttestation(ligneDemande: LigneDemandeDpaeDto): void {
    	const nomDocument = this.genererNomDocumentAttestation(ligneDemande);

    	ServicesFactoryInstance.DpaeService.genereAttestationDpae(ligneDemande.IdDemandeHistorique!, (r: Blob) => {
    		this.telechargerPdf(r, nomDocument);
    		this.dataReady = true;
    	}, () => {
    		NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération de l'attestation DPAE");
    		this.dataReady = true;
    	});
	}

	private telechargerPdf(blob: Blob, nomDocument: string): void {
    	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    		window.navigator.msSaveOrOpenBlob(blob, nomDocument);
    		this.dataReady = true;
    	} else {
    		this.dataReady = true;

    		const link = document.createElement("a");
    		document.body.appendChild(link);

    		link.href = window.URL.createObjectURL(blob);
    		link.download = nomDocument;
    		link.click();
    	}
	}

	public openSalarie(idSalarie: number, fullName: string): void {
    	EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: fullName } });
	}
}



// WEBPACK FOOTER //
// ./src/components/dpae/dpae.ts